<div class="bg-gray-200 p-5 flex flex-row justify-between items-center">
    <h1 class="font-bold text-2xl">
      Pay With Klarna
    </h1>
    <button
      (click)="dialogRef.close({ status: false })"
      class="bg-neutral-700 text-white text-sm px-2 py-1 rounded-full"
      matTooltip="Close dialog"
    >
      X
    </button>
</div>

<mat-dialog-content class="mat-typography">
   <div class="p-4">
        @if (klarnaIframeUrl !== '') {
            <iframe [src]="klarnaIframeUrl" width="100%" height="500px" frameborder="0"></iframe>
        }
   </div>
   @if(klarnaStatus === 'DONE') {
    <div class="mt-4 p-4 flex flex-row justify-center">
        <button mat-raised-button color="primary" (click)="dialogRef.close()">DONE</button>
    </div>
   }
</mat-dialog-content>



